// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"215":"changepassword","741":"registerchange"}[chunkId] + "." + {"215":"3e2fd3e0","741":"830f8c3c"}[chunkId] + ".js";
};